import api from "./api";

const studyMaterialDocumentService = {
  list: (params) => api.get("/study-material/documents", { params }),

  upload: ({ title, description, file, onUploadProgress }) => {
    const fd = new FormData();
    fd.append("title", title);
    if (description != null) fd.append("description", description);
    fd.append("file", file);

    return api.post("/study-material/documents/upload", fd, {
      onUploadProgress,
    });
  },

  downloadUrl: (id) => `/study-material/documents/${id}/download`,

  delete: (id) => api.delete(`/study-material/documents/${id}`),
};

export default studyMaterialDocumentService;

